import styled from "styled-components";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PrimaryButton, SecondaryButton } from "../components/Button";
import { Spacer } from "../editor/EditorHelpers";
import { Certificate, CertificateType } from "./Certificate";
import { CertificateContainer, ChallengeButtonBar, ChallengeLearnMore, ChallengeSubheader } from "./ChallengeHelpers";
import { useTranslation } from "react-i18next";
import { getDefaultChecks } from "./progressModel";



export default function EmptyChallenge() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isLearnMoreOpen, setLearnMoreOpen] = useState(false);
  const [scale, setScale] = useState(1000 / 2322);
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    function updateScale() {
      if (containerRef.current) {
        const width = containerRef.current.offsetWidth;
        console.log("setScale", width)
        setScale(width / 2322);
      }
    }

    updateScale();
    window.addEventListener('resize', updateScale);
    return () => window.removeEventListener('resize', updateScale);
  }, []);

  const handleJoin = () => {
    // Current path: /challenge/join/y7gaH9
    const parts = location.pathname.split('/'); // ["", "challenge", "join", "y7gaH9"]

    if (parts.length >= 3 && parts[1] === 'challenge') {
      const newPath = `/challenge/join/${parts[2]}`; 
      navigate(newPath);
    } else {
      // fallback if structure isn't as expected
      navigate('/challenge/join');
    }
  };


  return (
    <>
      <Header>{t('challenge.empty-challenge.header')}</Header>
      <ChallengeSubheader>{t('challenge.empty-challenge.subheader')}</ChallengeSubheader>
      {<ChallengeButtonBar>
        <Spacer style={{flexGrow: 1}} />
        <SecondaryButton onClick={() => setLearnMoreOpen(true)}>{t('learn-more.button')}</SecondaryButton>
        <PrimaryButton onClick={handleJoin}>{t('challenge.join-challenge.button')}</PrimaryButton>
        <Spacer style={{flexGrow: 1}} />
      </ChallengeButtonBar>}
      <CertificateContainer ref={containerRef}>
        <Certificate
          type={CertificateType.GREEN}
          width={2322}
          height={1220}
          scale={scale}
          header={t('challenge.cert.buy-european-challenge.header')}
          subheader={t('challenge.cert.empty-buy-european.subheader')}
          checks={getDefaultChecks(t)}
        />
      </CertificateContainer>

      {isLearnMoreOpen && <ChallengeLearnMore onClose={() => setLearnMoreOpen(false)} />}
    </>
  )
}

const Header = styled.h1`

`